export const RESET_CUSTOMER_GIFT_CARD_ISFETCHING =
  'RESET_CUSTOMER_GIFT_CARD_ISFETCHING';
export const LIST_CUSTOMER_GIFT_CARD_REQUEST =
  'LIST_CUSTOMER_GIFT_CARD_REQUEST';
export const LIST_CUSTOMER_GIFT_CARD_SUCCESS =
  'LIST_CUSTOMER_GIFT_CARD_SUCCESS';
export const CUSTOMER_GIFT_CARD_LIST_REQUESTING =
  'CUSTOMER_GIFT_CARD_LIST_REQUESTING';
export const CUSTOMER_GIFT_CARD_OBJECT_REQUESTING =
  'CUSTOMER_GIFT_CARD_OBJECT_REQUESTING';
export const REGISTER_CUSTOMER_GIFT_CARD_REQUEST =
  'REGISTER_CUSTOMER_GIFT_CARD_REQUEST';
export const GET_CUSTOMER_GIFT_CARD_SUCCESS = 'GET_CUSTOMER_GIFT_CARD_SUCCESS';
